import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

// Custom DateAdapter to consistently use dd/MM/yyyy for input/display
@Injectable()
export class DdMmYyyyDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (value instanceof Date && !isNaN(value.getTime())) return value;
    if (typeof value !== 'string') return null;

    const v = value.trim().replace(/-/g, '/');
    const m = /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/.exec(v);
    if (!m) return null;

    const dd = Number(m[1]);
    const mm = Number(m[2]);
    let yyyy = Number(m[3]);
    if (yyyy < 100) {
      // Interpret 2-digit years as 2000-2099 to avoid ambiguity
      yyyy += 2000;
    }

    if (mm < 1 || mm > 12) return null;
    const date = new Date(yyyy, mm - 1, dd);
    if (isNaN(date.getTime())) return null;
    if (
      date.getFullYear() !== yyyy ||
      date.getMonth() !== mm - 1 ||
      date.getDate() !== dd
    ) {
      return null;
    }
    return date;
  }

  override format(date: Date, displayFormat: any): string {
    const p = (n: number) => String(n).padStart(2, '0');
    return `${p(date.getDate())}/${p(date.getMonth() + 1)}/${date.getFullYear()}`;
  }
}

// Reusable app-wide date formats
export const APP_DATE_FORMATS = {
  parse: { dateInput: 'dd/MM/yyyy' },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'dd/MM/yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

export type AppDateFormats = typeof APP_DATE_FORMATS;



